exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-row[data-v-78c489b6] {\n  margin-bottom: 20px;\n}\n.header-row .search-fabric[data-v-78c489b6] {\n  height: 38px;\n}", ""]);

// exports
